import type { AgrReportRow } from "./api";

// ============================================================================
// Shared agreement filter matcher — resolves a saved segment's filter
// definition into matching members. Used by the agreements command center to
// render a saved segment as a worklist tab.
//
// NOTE: CustomReport.tsx (the builder) currently carries its own copy of this
// same logic. Keep the two in sync; consolidate onto this module when
// convenient. The shape here IS the segment `definition.filters` (DEC-24).
// ============================================================================

export interface FilterRow { id: number; field: string; op: string; value: string }

function rowValue(r: AgrReportRow, field: string): string | number | null {
  switch (field) {
    case "status": return r.status;
    case "plan": return r.plan;
    case "dept": return r.dept;
    case "zone": return r.zone;
    case "type": return r.type;
    case "value": return r.value;
    case "expires": return r.expires;
    case "signed": return r.signed;
    default: return null;
  }
}

export function passes(r: AgrReportRow, f: FilterRow): boolean {
  if (!f.value) return true;
  const v = rowValue(r, f.field);
  switch (f.op) {
    case "is": return String(v ?? "") === f.value;
    case "gte": return Number(v ?? 0) >= Number(f.value);
    case "lte": return Number(v ?? 0) <= Number(f.value);
    case "after": return !!v && String(v) >= f.value;
    case "before": return !!v && String(v) <= f.value;
    default: return true;
  }
}

export function matchesAll(r: AgrReportRow, filters: FilterRow[]): boolean {
  return filters.every((f) => passes(r, f));
}
